import { FC } from 'react'

import { Portal } from '@trustycars/genie-ui/components'
import { Icon } from '@trustycars/genie-ui/icons'

import RecoveryCodeVerifyBlock from '$blocks/RecoveryCodeVerifyBlock'
import CarroIDApprovalBlock from '$blocks/CarroIDApprovalBlock'
import PasskeyAuthenticateBlock from '$blocks/PasskeyAuthenticateBlock'
import PasswordVerifyBlock from '$blocks/PasswordVerifyBlock'

import BaseModal, { BaseModalContent } from '$elements/BaseModal'

import { AuthFactorTypes } from '$constants/auth'
import useMFABlock from '$actions/useMFABlock'

import Choice from './Choice'
import OTPBlock from '../OTPBlock'
import TOTPBlock from '../TOTPBlock'

import { closeButton, content, navControl } from './styles.css'

export type MFABlockProps = ReturnType<typeof useMFABlock>

const narrowFactorTypes: AuthFactorTypes[] = [
  'email_otp',
  'sms_otp',
  'lark_otp',
  'totp',
  'recovery_code',
  'password'
]

const Block: FC<MFABlockProps> = ({
  modalProps,
  disabled,
  factorControllers: {
    emailOTP,
    smsOTP,
    authenticatorTOTP,
    larkOTP,
    recoveryCode,
    carroAuthenticatorApproval,
    passkey,
    password
  },
  data,
  onSelect,
  onBack,
  selectedFactor,
  showChoices
}) => (
  <BaseModal {...modalProps}>
    <BaseModalContent
      className={content({
        isNarrow: selectedFactor && narrowFactorTypes.includes(selectedFactor)
      })}
    >
      <div className={navControl}>
        <button
          type="button"
          className={closeButton}
          onClick={onBack}
          tabIndex={-1}
        >
          <Icon namespace="Backward" />{' '}
          {showChoices ? 'Back' : 'Try another method'}
        </button>
      </div>

      {showChoices && (
        <Choice data={data} onClick={onSelect} disabled={disabled} />
      )}

      {selectedFactor == 'email_otp' && <OTPBlock {...emailOTP.otpBlock} />}

      {selectedFactor == 'sms_otp' && <OTPBlock {...smsOTP.otpBlock} />}

      {selectedFactor == 'lark_otp' && <OTPBlock {...larkOTP.otpBlock} />}

      {selectedFactor == 'totp' && (
        <TOTPBlock {...authenticatorTOTP.totpBlock} />
      )}

      {selectedFactor == 'recovery_code' && (
        <RecoveryCodeVerifyBlock {...recoveryCode.formProps} />
      )}

      {selectedFactor == 'password' && (
        <PasswordVerifyBlock {...password.formProps} />
      )}

      {selectedFactor == 'carro_id' && (
        <CarroIDApprovalBlock {...carroAuthenticatorApproval} />
      )}

      {selectedFactor == 'passkey' && <PasskeyAuthenticateBlock {...passkey} />}
    </BaseModalContent>
  </BaseModal>
)

export const MFABlock: FC<MFABlockProps> = props => (
  <Portal>
    <Block {...props} />
  </Portal>
)

export default MFABlock
